import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import {LocationStrategy} from '@angular/common';
import { NewBookingComponent } from './new-booking/new-booking.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../_utility';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';
import { Passenger } from '../../_models/Passenger';
import { ApiService } from '../../_services';
import { PassengerReservation } from '../../_models/Reservation';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { forkJoin } from 'rxjs';
import { Restaurant } from '../../_models/Restaurant';
import { ConfirmDialogComponent } from '../../_components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TableModule, ButtonModule, Tooltip, TranslateModule, DynamicDialogModule],
})
export class AdministrationComponent implements OnInit {
  public datasource: PassengerReservation[] = [];
  uuid_passenger: string | undefined;
  passenger: Passenger | undefined;
  restaurants: Restaurant[] = [];
  public companions: Array<Passenger> = [];

  constructor(
    private location: LocationStrategy,
    public dialog: DialogService,
    private router: Router,
    private breadcrumb: BreadcrumbsService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private spinner: SpinnerService
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.ADMINISTRATION_TABLE.path);
    }, 200);
    this.route.queryParams.subscribe((param) => {
      if (param) {
        this.uuid_passenger = param['passengerId'];
        this.initForm();
      }
    });
  }
  initForm() {
    this.spinner.show();
    forkJoin({
      reservations: this.apiService.PassengerReservations(this.uuid_passenger!),
      passenger: this.apiService.Passenger(this.uuid_passenger!),
      restaurants: this.apiService.Restaurants(),
    }).subscribe({
      next: ({ reservations, passenger, restaurants }) => {
        this.datasource = reservations;
        this.passenger = passenger;
        this.restaurants = restaurants;
        this.spinner.hide();
      },
      error: (err) => {
        console.log(err);
        this.spinner.hide();
      },
    });
  }

  Back() {
    this.goTo('administration');
  }

  NewBooking() {
    const ref = this.dialog.open(NewBookingComponent, {
      styleClass: 'resizableDialog',
      header: this.translate.instant('passenger_reservation.new_booking'),
      width: '50vw',
      modal: true,
      closable: true,
      data: {
        passenger: this.passenger,
        restaurants: this.restaurants,
      },
    });

    ref?.onClose.subscribe((o: any) => {
      if (o) {
        this.initForm();
      }
    });
  }

  UpdateBooking(reservation: PassengerReservation) {
    this.spinner.show();
    this.apiService
      .ReservationCompanions(
        this.passenger?.uuid_passenger!,
        reservation.id_reservation
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          const ref = this.dialog.open(NewBookingComponent, {
            styleClass: 'resizableDialog',
            header: this.translate.instant('passenger_reservation.update_booking'),
            width: '70vw',
            modal: true,
            closable: true,
            data: {
              passenger: this.passenger,
              restaurants: this.restaurants,
              reservation: reservation,
              selectedPassengers: data,
            },
          });

          ref?.onClose.subscribe((o: any) => {
            if (o) {
              this.initForm();
            }
          });
        },
        error: (error) => {
          this.spinner.hide();
          console.error(error);
        },
      });
  }

  DeleteBooking(data: PassengerReservation) {
    const ref = this.dialog.open(ConfirmDialogComponent, {
      styleClass: 'resizableDialog',
      header: this.translate.instant('confirm_dialog.delete_reservation_title'),
      width: '50vw',
      modal: true,
      closable: true,
      data: {},
    });

    ref?.onClose.subscribe((o: any) => {
      if (o) {
        this.spinner.show();
        this.apiService.DeleteReservation(data.id_reservation).subscribe({
          next: () => {
            this.spinner.hide();
            this.initForm();
          },
          error: (error) => {
            console.error(error);
            this.spinner.hide();
          },
        });
      }
    });
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'booking_management': {
        this.router.navigate(Constants.Routing.HOME_PRENOTAZIONI.routerLink);
        break;
      }
      case 'administration': {
        this.router.navigate(Constants.Routing.ADMINISTRATION.routerLink);
        break;
      }
    }
  }
}
